require("!!C:\\Users\\Prakosa\\Documents\\FIF\\action-web\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Prakosa\\Documents\\FIF\\action-web\\node_modules\\raw-loader\\index.js!C:\\Users\\Prakosa\\Documents\\FIF\\action-web\\node_modules\\jquery-slimscroll\\jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-slimscroll/jquery.slimscroll.js
// module id = 855
// module chunks = 3